import { FALLBACK_APPLICATION_MODE } from '../constants/index';
let currentApplicationMode = FALLBACK_APPLICATION_MODE;
export function setApplicationMode(name) {
    currentApplicationMode = name;
}
export const isApplicationMode = (name) => currentApplicationMode === name;
